import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AdvisorCard from './AdvisorNetwork/AdvisorCard';
import {
  addFollowingId,
  getFollowingIds,
} from '../utils/advisorNetworkConstants';

const AdvisorMatch = ({ user }) => {
  const [advisors, setAdvisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [followingIds, setFollowingIds] = useState(() => new Set());
  const [followLoadingId, setFollowLoadingId] = useState(null);

  useEffect(() => {
    if (user?.user_id) {
      setFollowingIds(new Set(getFollowingIds(user.user_id)));
    }
  }, [user?.user_id]);

  useEffect(() => {
    const loadMatches = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get('/api/advisor-network/match');
        setAdvisors(response.data?.advisors || []);
      } catch (err) {
        console.error('Failed to load advisor matches:', err);
        setError('Unable to load matched advisors.');
      } finally {
        setLoading(false);
      }
    };

    loadMatches();
  }, []);

  const handleFollow = async (advisorId) => {
    setFollowLoadingId(advisorId);
    try {
      await axios.post(`/api/advisor-network/follow/${advisorId}`);
      setFollowingIds((prev) => new Set(prev).add(advisorId));
      if (user?.user_id) {
        addFollowingId(user.user_id, advisorId);
      }
    } catch (err) {
      console.error('Follow failed:', err);
    } finally {
      setFollowLoadingId(null);
    }
  };

  return (
    <section className="mt-12 pt-10 border-t border-hairline">
      <h2 className="text-body font-medium text-ink mb-6">Advisors matched to your Visions</h2>

      {loading ? (
        <div className="py-8 text-center">
          <div className="w-8 h-8 mx-auto mb-3 border-2 border-hairline border-t-pine rounded-full animate-spin" />
          <p className="text-label text-ink-muted">Finding advisors…</p>
        </div>
      ) : error ? (
        <p className="text-body text-ink-muted">{error}</p>
      ) : advisors.length === 0 ? (
        <p className="text-body text-ink-muted">No matched advisors available yet.</p>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            {advisors.map((advisor) => (
              <AdvisorCard
                key={advisor.advisor_id}
                advisor={advisor}
                compact
                following={followingIds.has(advisor.advisor_id)}
                followLoading={followLoadingId === advisor.advisor_id}
                onFollow={handleFollow}
              />
            ))}
          </div>
          <Link
            to="/advisor-network"
            className="text-body text-pine hover:underline transition-colors duration-300"
          >
            See all advisors →
          </Link>
        </>
      )}
    </section>
  );
};

export default AdvisorMatch;
